var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fixed bottom-0 ml-5 mb-3"},[_vm._v(" Shoot me the answer in my DMs 📨 ")])}
var staticRenderFns = []

export { render, staticRenderFns }